import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import GroupRailLayout from '@/features/groupRail/GroupRailLayout';
import type { RailBadge } from '@/features/groupRail/GroupRailListItem';
import { usePollBadgesContext } from '@/context/PollBadgesContext';
import PollListPane from './PollListPane';
import PollDetailPane from './PollDetailPane';

/**
 * Polls workspace: cross-org group rail + content pane.
 * Routes: /polls (auto-select), /polls/:groupId, /polls/:groupId/p/:pollId.
 */
export default function PollsLayout() {
  const { groupId, pollId } = useParams();
  const { byGroup } = usePollBadgesContext();

  // Red bubble = open polls awaiting the user's vote; gray = participated
  const badges = useMemo(() => {
    const map: Record<string, RailBadge> = {};
    for (const [gid, b] of Object.entries(byGroup)) {
      if (b.unvoted > 0) map[gid] = { count: b.unvoted, urgent: true };
      else if (b.open > 0) map[gid] = { count: b.open, urgent: false };
    }
    return map;
  }, [byGroup]);

  return (
    <GroupRailLayout
      basePath="/polls"
      lastViewKey="flock_polls_last_view"
      collapseKey="flock_polls_sidebar_collapsed"
      emptyHint="Select a group to see its polls."
      selectedGroupId={groupId ?? null}
      badges={badges}
      renderContent={(group) =>
        pollId ? (
          <PollDetailPane key={pollId} group={group} pollId={pollId} />
        ) : (
          <PollListPane key={group.id} group={group} />
        )
      }
    />
  );
}
